<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='InvOrders' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh" id='invOrders-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'orderCode'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'invOrders')">{{ scope.row.orderCode }}</a>
                </span>
              <span v-else-if="item.key === 'orderPlanCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'tx_orderplans')">{{ scope.row.orderPlanCode }}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{ scope.row[item.key] | dateFormat }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="invOrders-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="invOrders-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp" :solt-name-array="soltNameArray">
        <template slot="cPTCode">
          <el-select slot="cPTCode" v-model="temp.cPTCode" @change="setcPtCode" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item.value">
            </el-option>
          </el-select>
        </template>

      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as invOrders from '@/api/invorders';
import mytable from '@/utils/crmtableFlowV2';
import * as tx_orderplans from '@/api/tx_orderplans';

export default {
  name: 'invOrders',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'InvOrder',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      soltNameArray: ['cPTCode'],
      rules: {},
      options: []
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return invOrders;
    },
    setcPtCode(val) {
      this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('cPTCode', val);
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnErp':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Erp();
          }
          break;
        case 'btnWaiver':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Waiver();
          }
          break;
        case 'btnClose':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Close();
          }
          break;
      }
    },
    Close() {
      this.$confirm('是否要关闭', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.state !== 0 && u.state !== 2 && u.state !== 3);
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(','),
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          invOrders.Close(paramStr).then(res => {
            this.$message({
              message: '关闭成功',
              type: 'success'
            });
            this.getList();
          }).catch((_) => {
          });
        } else {
          this.$message({
            message: '请选择状态为已提交的单据！',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    Waiver() {
      this.$confirm('是否要弃审', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const state = this.multipleSelection[0].state;
        this.listLoading = true;
        if (state === 0) {
          this.$message({
            message: '该订单尚未提交到ERP，无需弃审!',
            type: 'error'
          });
          this.getList();
        } else if (state === 2) {
          this.$message({
            message: '该订单已弃审，无需再次弃审!',
            type: 'error'
          });
          this.getList();
        } else if (state === 3) {
          this.$message({
            message: '该订单已关闭，不可弃审!',
            type: 'error'
          });
          this.getList();
        } else {
          invOrders.Back(this.multipleSelection[0].id).then(res => {
            this.$message({
              message: '弃审成功',
              type: 'success'
            });
            this.getList();
          }).catch((_) => {
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    Erp() {
      const paramStr = this.multipleSelection[0].id;
      invOrders.get(paramStr).then(response => {
        this.temp = response.result == null ? {} : response.result;
        if (this.accList) {
          const tempaccindex = this.accList.findIndex(u => u.accountId === this.getAccountId());
          if (tempaccindex > -1) {
            this.temp.deptCode = this.accList[tempaccindex].erpDeptCode;
            this.temp.erpUserCode = this.accList[tempaccindex].erpUserCode;
            this.temp.erpUser = this.accList[tempaccindex].erpUser;
          }
        }
        this.temp.orderDetail.forEach(item => {
          item.isClose = item.isClose.toString();
        });
        this.options = response.otherData;
        this.dialogStatus = 'update';
        this.dialogEditVisible = true;
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'invOrders') {
        this.getApi().get(row.id).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'invordersview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      } else if (type === 'tx_orderplans') {
        tx_orderplans.get(row.planID).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_orderplansview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#invOrders-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
